<template>
  <div class="pdl">
    <el-row v-if="!disabled" type="flex" class="mb10">
      <el-button type="primary" @click="openModal">添加商品</el-button>
      <el-button type="primary" @click="clearList">清空</el-button>
    </el-row>
    <el-table border header-cell-class-name="tableHeader" :data="list">
      <el-table-column label="商品编码" fixed width="200px" prop="productCode"></el-table-column>
      <el-table-column label="商品名称" fixed width="200px" prop="productName"></el-table-column>
      <el-table-column label="规格" width="100px" prop="spec"></el-table-column>
      <el-table-column label="数量（盒/瓶）" width="120px">
        <template slot-scope="scope">
          <el-input v-model="scope.row.num" placeholder="请输入数量" :disabled="disabled"  @input="getNum(scope.row,scope.$index)"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="商品单价（元）" width="120px">
        <template slot-scope="scope">
          <el-input v-model="scope.row.productPrice" placeholder="请输入商品单价" disabled></el-input>
        </template>
      </el-table-column>
      <!-- <el-table-column label="配额外价格" min-width="130px" prop="quotaPrice"></el-table-column> -->
      <!-- <el-table-column label="折扣类型" min-width="120px">
        <template slot-scope="scope">
          <el-select v-model="scope.row.discountType"  disabled placeholder="请选择">
            <el-option v-for="item in prizeOptList" :label="item.dictValue" :value="item.dictCode"
              :key="item.dictCode"></el-option>
          </el-select>
        </template>
      </el-table-column> -->
      <!-- <el-table-column label="折扣率" min-width="130px" prop="discountRate"></el-table-column>
      <el-table-column label="折扣" min-width="130px" prop="discountPrice"></el-table-column>
      <el-table-column label="折后金额" min-width="130px" prop="discountAfterPrice"></el-table-column> -->
      <el-table-column label="总金额（元）" min-width="130px" prop="productTotalPrice"></el-table-column>
      <!-- <el-table-column label="数量从" min-width="130px" prop="fromPriceNumber"></el-table-column>
      <el-table-column label="数量到" min-width="130px" prop="toPriceNumber"></el-table-column> -->
      <el-table-column label="销售区域" min-width="400px" prop="saleArea" v-if="disabled"></el-table-column>
      <el-table-column label="销售区域" min-width="400px" v-else>
        <template slot-scope="scope">
          <el-cascader  v-model="scope.row.saleArea"  style="width: 100%;" :disabled="disabled" :options="areaOptions" :props="cascaderProps"
            clearable :show-all-levels="true" placeholder="请选择销售区域"
            @change="toFather"></el-cascader>
        </template>
      </el-table-column>
      <!-- <el-table-column label="状态" min-width="130px" prop="enableStatusName"></el-table-column> -->
      <el-table-column v-if="!disabled" label="操作" width="80px" fixed="right">
        <template slot-scope="scope">
          <span class="delIcon" @click="deleteItem(scope.$index)">删除</span>
        </template>
      </el-table-column>
    </el-table>
    <!-- <el-button @click="lookD">查看数据</el-button>
      <el-button @click="lookDt">查看数据1</el-button> -->
    <SelectConfig ref="selectConfig" @onGetSelect="onGetSelect" />
  </div>
</template>
<script>
import request from '@/found/utils/request';
import SelectConfig from '@/found/components/select_org_cus_ter/select_config.vue';

// import NewTreeSelect from './form_tree.vue';

export default {
  props: {
    value: [Array, Object],
    disabled: Boolean,
    fApi: Object,
    getRule: Function,
    setValue: Function,
  },
  components: {
    SelectConfig,
  },
  data() {
    return {
      list: [],
      cascaderProps: {
        children: 'childList',
        label: 'regionName',
        value: 'regionName',
        multiple: true,
        checkStrictly: true,
      },
      areaOptions: [],
      selectedAreas: [], // 多选绑定值
      prizeOptList: [],
    };
  },
  watch: {
    value: {
      deep: true,
      handler(value) {
        console.log('// 标记为已执行');
        console.log(value);
        if (value) {
          if (!this.disabled) {
            const dArry = [];
            value.map((item) => {
              const v = item;
              v.dArry = [];
              if (v.saleArea.includes(',')) {
                const splArry = v.saleArea.split(',').map((citem) => citem.trim());
                console.log('splArry', splArry);
                splArry.forEach((sitem) => {
                  console.log('sitem', sitem);
                  if (sitem.includes('/')) {
                    console.log(1);
                    v.dArry.push(sitem.split('/'));
                    v.saleArea = v.dArry;
                  }
                });
              } else if (v.saleArea.includes('/')) {
                console.log(2);
                v.saleArea = [v.saleArea.split('/')];
              }
              return v;
            });
          }
          this.list = value;
        }
      },
    },
  },
  async mounted() {
    this.getDictList();
    this.getTreeData();
  },
  methods: {
    // 新增弹窗
    openModal() {
      console.log(this.value);
      const companyCode = this.getRule('companyCode').value;
      console.log(companyCode);
      if (!companyCode) {
        this.$message.error('请选择公司主体');
        return;
      }

      const params = {
        functionCode: 'productList',
        noReset: true,
        paramData: {
          companyCode,
          enableStatus: '009',
          status: '1',
        },
        pageAble: false,
        data: this.list,
        selectionList: [],
        idKey: 'productCode',
      };
      this.$refs.selectConfig.openSelectModal(params);
    },
    // 清空
    clearList() {
      this.list = [];
      this.toFather();
    },
    getNum(val, index) {
      console.log(val, index);
      this.list[index].productTotalPrice = (this.list[index].num * this.list[index].productPrice).toFixed(2);
      this.toFather();
    },
    // 区域数据转换
    parseAddress(str) {
      const primaryArray = str.split(',').map((item) => item.trim());
      return primaryArray.map((address) => {
        // 检查是否存在斜杠分隔符
        if (address.includes('/')) {
          // 拆分并过滤空值
          return address.split('/').filter(Boolean);
        }
        // 无斜杠时返回单元素数组
        return [address];
      });
    },
    onGetSelect(val) {
      console.log('onGetSelect ~ val:', val);
      this.list = val;
      this.$emit('input', this.list);
    },
    // 获取区域树
    async getTreeData() {
      request.post('/mdm/mdmRegionController/treeList').then((res) => {
        console.log('区域', res.result.data);
        this.areaOptions = res.result.data;
      });
    },
    // 暴露数据
    toFather() {
      let contAmount = 0;
      this.list.forEach((vitem) => {
        contAmount += (vitem.num * vitem.productPrice);
        console.log('contAmount', contAmount);
        console.log(this.getRule('contractTotalAmount'));
      });
      this.setValue({
        contractTotalAmount: contAmount.toFixed(2),
      });
      this.$emit('input', this.list);
    },
    // 行删除
    deleteItem(index) {
      this.list.splice(index, 1);
      this.toFather();
    },
    // 获取数据字典
    getDictList() {
      request
        .post('/mdm/mdmdictdata/batchDictSelect', [
          'ins_type',
        ])
        .then((res) => {
          console.log('res', res);
          if (res.success) {
            this.prizeOptList = res.result.ins_type || [];
          }
        });
    },

  },
};
</script>
  <style lang="less" scoped>
  .pdl {
    //padding-left: 125px;
  }

  /deep/ .tableHeader {
    background-color: #e8e8e8 !important;
  }

  /deep/ .el-tag {
    margin: 4px;
  }

  .mb10 {
    margin-bottom: 10px;
  }

  .delIcon {
    color: #e16063;
    cursor: pointer;
  }

  .addProIcon {
    color: #169bd5;
    cursor: pointer;
    margin: 4px;
  }

  .avatarUploader {
    .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    .el-upload:hover {
      border-color: #409eff;
    }

    .avatar {
      width: 100px;
      height: 100px;
      display: block;
    }

    .avatarUploaderIcon {
      font-size: 28px;
      color: #8c939d;
      width: 100px;
      height: 100px;
      line-height: 100px;
      text-align: center;
    }
  }

  .cusEtag {
    white-space: break-spaces;
    word-break: break-all;
    height: auto;
    position: relative;
    padding-right: 14px;

    /deep/ .el-icon-close {
      position: absolute;
      right: 1px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .tD {
    width: 100%;
    margin-top:20px;

    .tD_area {
      display: flex;
      align-items: center;
      margin-bottom: 10px;

      .tD_right {
        margin-left: 20px;
        font-size: 14px;
        color: #606266;
        display: flex;
        align-items: center;
      }

      .tD_left {
        font-size: 14px;
        color: #606266;
        width:275px;
        span{
          color:#de4e52;
           font-size: 14px;
        }
      }

    }
  }
  </style>
